import styled from 'styled-components';

export const SkinPath = styled.path`
  fill: #ffa1b0;
`;
